import {
  FormControl,
  FormControlProps,
  FormHelperText,
  FormLabel,
} from '@chakra-ui/react';
import React from 'react';

import VisuallyHidden from '../../VisuallyHidden';
import * as Styles from './FormField.module.scss';

export enum HelperTextPosition {
  top = 'top',
  bottom = 'bottom',
}

export enum FormFieldVariant {
  light = 'light',
  claims = 'claims',
  primary = 'primary',
}

export interface FormFieldProps extends FormControlProps {
  name: string;
  label?: string;
  hideLabel?: boolean;
  variant?: FormFieldVariant;
  required?: boolean;
  showRequiredLabel?: boolean;
  helperText?: string;
  helperTextPosition?: HelperTextPosition;
  isFieldSet?: boolean;
}

const RequiredIndicator: React.FC = () => (
  <b className={Styles.requiredIndicator + ' required-indicator'}>Required</b>
);

const FormField: React.FC<FormFieldProps> = ({
  label,
  hideLabel,
  name,
  helperText,
  required,
  showRequiredLabel,
  variant,
  helperTextPosition = HelperTextPosition.top,
  isFieldSet,
  isInvalid,
  children,
  ...rest
}) => {
  const helperTextContent = helperText && (
    <FormHelperText
      textAlign="left"
      fontSize="xs"
      marginY={1}
      paddingLeft={
        FormFieldVariant.claims || (FormFieldVariant.primary && '8px')
      }
    >
      {helperText}
    </FormHelperText>
  );

  return (
    <FormControl
      id={name}
      isRequired={required}
      variant={variant}
      as={isFieldSet ? 'fieldset' : undefined}
      isInvalid={isInvalid}
      {...rest}
    >
      <VisuallyHidden isHidden={hideLabel}>
        <FormLabel
          fontSize="sm"
          color={
            variant === FormFieldVariant.light
              ? 'white'
              : variant === FormFieldVariant.claims
              ? '#003366'
              : undefined
          }
          requiredIndicator={
            showRequiredLabel ? <RequiredIndicator /> : undefined
          }
          as={isFieldSet ? 'legend' : undefined}
          variant={FormFieldVariant.primary}
        >
          {label}
        </FormLabel>
      </VisuallyHidden>

      {helperTextPosition === HelperTextPosition.top && helperTextContent}
      {children}
      {helperTextPosition === HelperTextPosition.bottom && helperTextContent}
    </FormControl>
  );
};

export default FormField;
